module.exports = __webpack_public_path__ + "img/Storage=Storage-On.139db637.svg";